export default {
  authenticated: false,
  checked: false,
};



// WEBPACK FOOTER //
// ./src/app/features/authentication/authentication.state.js